export default "__VITE_ASSET__BguJhD$6__"